export default "__VITE_ASSET__$HXcdqdI__"